import { useState } from "react";
import { BarChartDay, BarChartMonth, BarChartYear } from '../../../components/EnergyBarCharts'
import { CostsAndCO2Panel, VirtualCounterCostsAndCO2Panel } from '../BaseCounter/CostsAndCO2Panel'
import { OperatorPanelWrapperFullSize } from '../../components/Layout'
import { IVirtualCounter } from './types'
import { useGetMediumColor } from '../../../hooks/useGetMediumColor'
import { FormattedMessage, useIntl } from "react-intl";
import { Block } from "baseui/block";
import { ButtonGroup, MODE } from "baseui/button-group";
import { Button } from "baseui/button";
import { BsCalendar2Month, BsCalendar3, BsCalendarDate } from "react-icons/bs";
import { useStyletron } from "baseui";


export const OperatorPanel = (props: IVirtualCounter) => {
    const [css, theme] = useStyletron();
    const [color] = useGetMediumColor(props.counterMedium, props.counterType);
    const [activeKey, setActiveKey] = useState<number>(0);
    const intl = useIntl();
   
    return (
        <OperatorPanelWrapperFullSize
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    {activeKey === 0 && <VirtualCounterCostsAndCO2Panel currencyCode={props.currencyCode} id={props.id} resourceGroupId={props.resourceGroupId} counterType={props.counterType} dimension={props.dimension} days={7}></VirtualCounterCostsAndCO2Panel>}
                    {activeKey === 1 && <VirtualCounterCostsAndCO2Panel currencyCode={props.currencyCode} id={props.id} resourceGroupId={props.resourceGroupId} counterType={props.counterType} dimension={props.dimension} days={365}></VirtualCounterCostsAndCO2Panel>}
                    {activeKey === 2 && <VirtualCounterCostsAndCO2Panel currencyCode={props.currencyCode} id={props.id} resourceGroupId={props.resourceGroupId} counterType={props.counterType} dimension={props.dimension} days={5 * 365}></VirtualCounterCostsAndCO2Panel>}

                </>
            }
            operationModeContent={
                <Block width={'100%'} height={'100%'} display='flex' flexDirection={'column'} gridGap={theme.sizing.scale800}>
                    <Block alignSelf={'center'}>
                        <ButtonGroup
                            size='mini'
                            mode={MODE.radio}
                            kind='secondary'
                            selected={activeKey}
                            onClick={(event, index) => {
                                setActiveKey(index);
                            }}>
                            <Button title={intl.formatMessage({ id: "Devices.Days", defaultMessage: "Days" })} startEnhancer={() => <BsCalendarDate></BsCalendarDate>}>{intl.formatMessage({ id: "Devices.Days", defaultMessage: "Days" })}</Button>
                            <Button title={intl.formatMessage({ id: "Devices.Months", defaultMessage: "Months" })} startEnhancer={() => <BsCalendar2Month></BsCalendar2Month>}><FormattedMessage id='Devices.Months' defaultMessage={'Months'}></FormattedMessage></Button>
                            <Button title={intl.formatMessage({ id: "Devices.Years", defaultMessage: "Years" })} startEnhancer={() => <BsCalendar3></BsCalendar3>}>{intl.formatMessage({ id: "Devices.Years", defaultMessage: "Years" })}</Button>
                        </ButtonGroup>
                    </Block>
                    <Block height={'400px'} minHeight={'300px'}>
                        {activeKey === 0 && <BarChartDay resourceGroupId={props.resourceGroupId}  color={color} responsive={true} id={props.id} objectDescription={props.description}  ></BarChartDay>}
                        {activeKey === 1 && <BarChartMonth resourceGroupId={props.resourceGroupId}  color={color} responsive={true} id={props.id} objectDescription={props.description}  ></BarChartMonth>}
                        {activeKey === 2 && <BarChartYear resourceGroupId={props.resourceGroupId}  color={color} responsive={true} id={props.id} objectDescription={props.description}  ></BarChartYear>}
                    </Block>
                </Block>
            }
        >
        </OperatorPanelWrapperFullSize>
    )

}

